module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"pc_connection_created":"გახსნილია კავშირი კლინიკასა და პაციენტს შორის"},"en":{"pc_connection_created":"Connection created between clinic and patient"}}')
  delete Component.options._Ctor
}
